module.exports = __webpack_public_path__ + "img/serget.8a5e1c7a.png";